/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type AnyAction, combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import * as localForage from 'localforage'
import authCredentials, { logout } from './authCredentials'

const rootPersistConfig = {
  key: 'AITool',
  storage: localForage
}

const authPersistConfig = {
  key: 'authCredentials',
  storage: localForage,
  whitelist: ['credentials']
}

const appReducer = persistReducer(
  rootPersistConfig,
  combineReducers({
    AuthCredentials: persistReducer(authPersistConfig, authCredentials)
  })
)

const rootReducer = (state: ReturnType<typeof appReducer>, action: AnyAction) => {
  if (action.type === logout.type) {
    void localForage.clear()
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state = {} as RootState
  }

  return appReducer(state, action)
}

export default rootReducer
export type RootState = ReturnType<typeof appReducer>
